import './NewsPage.css';

import React from 'react';

import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, useParams } from 'react-router';
import { AppPage } from '../AppContent';
import { EventItem } from '../components/event/EventItem';
import { EventsList } from '../components/event/EventsList';
import { TabData, Tabs } from '../components/globals/Tabs';
import { NewsGrid } from '../components/news/NewsGrid';
import { NewsItem } from '../components/news/NewsItem';
import { useEventsList } from '../hooks/EventHook';
import { useNewsView } from '../hooks/NewsHooks';
import { useNews } from '../hooks/WPHooks';
import { WP_Checklist } from '../model/checklist/checklist';
import { ChecklistService } from '../services/ChecklistService';
import { AppContext } from '../state/AppContextProvider';

interface NewsPageProps extends RouteComponentProps {}

const NewsPage: React.FC<NewsPageProps> = (props: NewsPageProps) => {
  const { state } = useContext(AppContext);

  const { slug }: any = useParams();

  const { events } = useEventsList();

  const { news: newsList } = useNews();

  const { news } = useNewsView(slug || '');

  // Merge newsList with slug'news and remove duplicates
  const newsMap = (news ? [...newsList, news] : [...newsList]).map(
    (it) => it.postId
  );
  const newsListMerged = (news ? [...newsList, news] : [...newsList]).filter(
    (it) => newsMap.indexOf(it.postId) > -1
  );

  const todoList = state.allChecklists.filter((c) => {
    const e = ChecklistService.getEntry(c.id, state.allChecklistsEntries);
    return (
      e &&
      !ChecklistService.isDone(c, e) && // not none
      ChecklistService.getAge(state.user, c) <= 30 // not more than 1 month
    );
  });

  const firstChecklist: WP_Checklist | null =
    todoList.length > 0 ? todoList[0] : null;

  const tabs: TabData[] = [
    {
      label: 'News',
      link: '/news',
      component: (
        <NewsGrid
          news={newsListMerged}
          baseUrl="/news"
          cols="2"
          itemRenderer={NewsItem}
          checklist={firstChecklist}
        />
      ),
    },
    {
      label: 'Events',
      link: '/events',
      component: (
        <EventsList
          events={events}
          baseUrl="/events"
          itemRenderer={EventItem}
        />
      ),
    },
  ];

  return (
    <AppPage scrollable={false}>
      <div className="px-4 md:px-14">
        <h1 className="text-3xl font-medium mb-4 hidden md:block">
          <FormattedMessage id="Hello" />
          <span className="text-primary"> {state.user?.first_name || ''}</span>,
        </h1>
      </div>
      <Tabs id="news-tabs" tabs={tabs} classT="" {...props} scrollable={true} />
    </AppPage>
  );
};

export default NewsPage;
